import { render, staticRenderFns } from "./TwoCube.vue?vue&type=template&id=2517e2c3&scoped=true&"
import script from "./TwoCube.vue?vue&type=script&lang=js&"
export * from "./TwoCube.vue?vue&type=script&lang=js&"
import style0 from "./TwoCube.vue?vue&type=style&index=0&id=2517e2c3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2517e2c3",
  null
  
)

export default component.exports